import { formatMoney } from '@theme/utilities';

(function updateProductPrice() {
  
  window.addEventListener('stay-ai-subscription-changed', (event) => {
    
    setTimeout(() => {
      const priceEl = document.querySelector('[ref="priceContainer"]')
      const staySubscriptionPrice = document.querySelector('[data-stayai-subscription-price]');
      const stayOTPPrice = document.querySelector('[data-stayai-onetime-price]')
      const stayPriceEl = document.querySelector('.stayai-product-price')
      const { detail } = event;
  
      if (!detail || !priceEl) return;
      const ogPrice = formatMoney(String(detail.variantPrice));
      const newPriceEl = document.createElement('div');
      newPriceEl.classList.add('stayai-product-price')
      const innerPriceEl = detail.sellingPlanId && staySubscriptionPrice 
        ? staySubscriptionPrice.innerHTML
        : stayOTPPrice?.innerHTML || `<span>${ogPrice}</span>`
     
  
      if (!stayPriceEl) {
        newPriceEl.innerHTML = innerPriceEl
        priceEl.before(newPriceEl);
        return
      }

      stayPriceEl.innerHTML = innerPriceEl

    }, 100);


  });
})();